import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="os" id="os"></a>
    <h1 {...{
      "id": "requireos"
    }}>{`require('os')`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://nodejs.org/api/os.html"
      }}>{`https://nodejs.org/api/os.html`}</a>{`  `}</p>
    <a name="os-platform" id="os-platform"></a>
    <h2 {...{
      "id": "platform"
    }}>{`platform()`}</h2>
    <p>{`Gets the platform we are running on (eg. "win32", "win10", "darwin")`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the string representing the platform  `}</p>
    <a name="os-release" id="os-release"></a>
    <h2 {...{
      "id": "release"
    }}>{`release()`}</h2>
    <p>{`Gets the release number of the os (eg. "10.0.1.1032")`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the string representing the release  `}</p>
    <a name="os-arch" id="os-arch"></a>
    <h2 {...{
      "id": "arch"
    }}>{`arch()`}</h2>
    <p>{`Gets the platform architecture we are running on (eg. "x32, x64, x86_64 etc")`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the string representing the architecture  `}</p>
    <a name="os-cpus" id="os-cpus"></a>
    <h2 {...{
      "id": "cpus"
    }}>{`cpus()`}</h2>
    <p>{`Gets the platform cpu information we are running on (eg. "{'Intel(R) Core(TM) i9-8950HK CPU @ 2.90GHz', 2900}")`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`array`}</inlineCode>{` - the array of objects containing information about each logical CPU core
Currently only model and speed properties are supported. times property is not supported.
Access to CPU information, such as model string and frequency, is limited on UWP.
"ARM based architecture" or "X86 based architecture" is returned as a 'model' value on UWP.
0 is returned as a 'speed' value on UWP.  `}</p>
    <a name="os-totalmem" id="os-totalmem"></a>
    <h2 {...{
      "id": "totalmem"
    }}>{`totalmem()`}</h2>
    <p>{`Gets the total amount of system memory in bytes`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`integer`}</inlineCode>{` - the total amount of system memory in bytes as an integer  `}</p>
    <a name="os-freemem" id="os-freemem"></a>
    <h2 {...{
      "id": "freemem"
    }}>{`freemem()`}</h2>
    <p>{`Gets the total amount of free system memory in bytes`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`integer`}</inlineCode>{` - the total amount of free system memory in bytes as an integer  `}</p>
    <a name="os-homedir" id="os-homedir"></a>
    <h2 {...{
      "id": "homedir"
    }}>{`homedir()`}</h2>
    <p>{`Gets the home directory path of the user`}</p>
    <p><strong parentName="p">{`Returns`}</strong>{`: `}<inlineCode parentName="p">{`string`}</inlineCode>{` - the home directory path of the user  `}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      